export const ConfigurationTemplateNames = {
  AU_TRAINING_LINK: 'vm.misc.crux.au.training.link',
  NZ_TRAINING_LINK: 'vm.misc.crux.nz.training.link',
};

export const ExpirationKeys = {
  PROPERTY_PREFERENCES_EXPIRATION: 'propertyPreferences',
  IMAGE_UPLOAD_EXPIRATION: 'imageUpload',
};

const SettingsUtil = {
  ConfigurationTemplateNames,
  ExpirationKeys,
};
export default SettingsUtil;
